import DTO from './DTO';

class CheckTypesDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'service_name',
        type: String,
        validators: {},
        labelKey: 'check.types.service_name',
      },
      {
        name: 'apply_to_registries',
        type: String,
        validators: {},
        labelKey: 'check.types.apply_to_registries',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'check.types.name',
      },
      {
        name: 'source',
        type: String,
        validators: {},
        labelKey: 'check.types.source',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'check.types.created_at',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'check.types.status',
      },
      {
        name: 'apply_to_procedures',
        type: String,
        validators: {},
        labelKey: 'check.types.apply_to_procedures',
      },
      {
        name: 'apply_to_legal_entity_types',
        type: String,
        validators: {},
        labelKey: 'check.types.apply_to_legal_entity_types',
      },
      {
        name: 'apply_to_citizenship',
        type: String,
        validators: {},
        labelKey: 'check.types.apply_to_citizenship',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'check.types.type',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default CheckTypesDTO;
